export const SALESPAYMENT_LOADING = "SALESPAYMENT_LOADING";
export const SALESPAYMENT_RESET = "SALESPAYMENT_RESET";
export const GET_SALESPAYMENT = "GET_SALESPAYMENT";
export const GET_SALESPAYMENT_SUCCESS = "GET_SALESPAYMENT_SUCCESS";
export const GET_SALESPAYMENT_FAIL = "GET_SALESPAYMENT_FAIL";
export const DELETE_SALESPAYMENT = "DELETE_SALESPAYMENT"
export const DELETE_SALESPAYMENT_SUCCESS = "DELETE_SALESPAYMENT_SUCCESS"
export const DELETE_SALESPAYMENT_FAIL = "DELETE_SALESPAYMENT_FAIL"
export const UPDATE_SALESPAYMENT = "UPDATE_SALESPAYMENT"
export const UPDATE_SALESPAYMENT_SUCCESS = "UPDATE_SALESPAYMENT_SUCCESS"
export const UPDATE_SALESPAYMENT_FAIL = "UPDATE_SALESPAYMENT_FAIL"
export const ADD_NEW_SALESPAYMENT = "ADD_NEW_SALESPAYMENT"
export const ADD_SALESPAYMENT_SUCCESS = "ADD_SALESPAYMENT_SUCCESS"
export const ADD_SALESPAYMENT_FAIL = "ADD_SALESPAYMENT_FAIL"